import React, { useEffect, useState } from "react";
import { IonItem, IonIcon, IonLabel, IonList } from "@ionic/react";

interface MenuItem {
  id: string;
  label: string;
  icon: string;
  color?: string;
  onClick: () => void;
}

interface OptionsMenuProps {
  post: any;
  isOpen: boolean;
  onDidDismiss: () => void;
  menuItems: MenuItem[];
  menuPosition: { top: number; right: number };
  setSelectedItemId?: React.Dispatch<React.SetStateAction<{ activeId: string; postId: string } | null>>;
  handleMenuItemClick: (id: string) => void;
}

const OptionsMenu: React.FC<OptionsMenuProps> = ({
  post,
  isOpen,
  onDidDismiss,
  menuItems,
  menuPosition,
  handleMenuItemClick
  // setSelectedItemId,
}) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const onClick = (item: MenuItem) => {
    setActiveId(item.id);
    console.log("Menu item clicked:", item.id);
    // if (setSelectedItemId) {
      // setSelectedItemId({ activeId: item.id, postId: post.id });
    // }
    handleMenuItemClick(item.id);
    onDidDismiss();
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "absolute",
        top: `${menuPosition.top}px`,
        right: `${menuPosition.right}px`,
        zIndex: 1000,
        backgroundColor: "white",
        borderRadius: "15px",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.15)",
        minWidth: "210px",
        padding: "1px 0",
        border: "1px solid #DADCDF",
        maxHeight: "60vh",
        overflowY: "auto",
      }}
    >
      <IonList style={{ padding: "0" }}>
        {menuItems.map((item, index) => (
          <React.Fragment key={item.id}>
            <IonItem
              button
              onClick={() => onClick(item)}
              style={{
                "--border-style": "none",
                "--inner-border-width":
                  index === menuItems.length - 1 ? "0" : "0 0 1px 0",
                "--inner-border-color": "#e5e5e5",
                "--padding-start": "16px",
                "--padding-end": "16px",
                cursor: "pointer",
              }}
            >
              <IonIcon
                icon={item.icon}
                slot="start"
                style={{
                  color: activeId === item.id ? "#05ACD9" : item.color || "#666",
                  fontSize: "20px",
                  marginRight: "12px",
                }}
              />
              <IonLabel
                style={{
                  color: activeId === item.id ? "#05ACD9" : item.color || "#333",
                  fontSize: "16px",
                  fontWeight: "400",
                  fontFamily: "Figtree",
                }}
              >
                {item.label}
              </IonLabel>
            </IonItem>
            {index !== menuItems.length - 1 && (
              <hr
                style={{
                  width: "100%",
                  borderColor: "#eee",
                  borderWidth: "1px",
                  margin: 0,
                }}
              />
            )}
          </React.Fragment>
        ))}
      </IonList>
    </div>
  );
};

export default OptionsMenu;
